export default {"src":"/_next/static/media/spyglass.2138c2b8.svg","height":512,"width":513};